"use client";

import { Instagram, Linkedin, Youtube, ArrowUpRight, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-3 w-24 bg-muted animate-pulse" />
        <div className="h-3 w-20 bg-muted animate-pulse" />
        <div className="h-3 w-28 bg-muted animate-pulse" />
        <div className="h-3 w-16 bg-muted animate-pulse" />
      </div>;
  }
  const half = Math.ceil(menuItems.length / 2);
  const colA = menuItems.slice(0, half);
  const colB = menuItems.slice(half);
  return <div className="grid grid-cols-2 gap-8">
      <div className="flex flex-col gap-4">
        <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-primary">
          § Programs
        </div>
        <ul className="flex flex-col gap-3">
          {colA.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="group relative inline-block font-default text-[0.78rem] tracking-[0.16em] uppercase text-muted-foreground hover:text-primary transition-colors duration-250">
                <span>{item.label}</span>
                <span className="absolute left-0 -bottom-1 h-px w-[60%] bg-primary opacity-0 group-hover:opacity-100 group-hover:w-full transition-all duration-250" />
              </Link>
            </li>)}
        </ul>
      </div>
      <div className="flex flex-col gap-4">
        <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-primary">
          § Resources
        </div>
        <ul className="flex flex-col gap-3">
          {colB.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="group relative inline-block font-default text-[0.78rem] tracking-[0.16em] uppercase text-muted-foreground hover:text-primary transition-colors duration-250">
                <span>{item.label}</span>
                <span className="absolute left-0 -bottom-1 h-px w-[60%] bg-primary opacity-0 group-hover:opacity-100 group-hover:w-full transition-all duration-250" />
              </Link>
            </li>)}
        </ul>
      </div>
    </div>;
}
const tickerItems = ["© 2024 HOPE TORCHLIGHTERS", "EST. 2018", "ADVOCACY", "RESPITE CARE", "NEURODIVERSE SUPPORT", "INCLUSIVE COMMUNITY", "EMPOWERING FAMILIES", "BEACON OF HOPE"];
const socials = [{
  name: "Instagram",
  href: "#",
  icon: Instagram
}, {
  name: "LinkedIn",
  href: "#",
  icon: Linkedin
}, {
  name: "YouTube",
  href: "#",
  icon: Youtube
}, {
  name: "X",
  href: "#",
  icon: X
}];
const legalLinks = [{
  label: "Privacy",
  href: "#"
}, {
  label: "Terms",
  href: "#"
}, {
  label: "Accessibility",
  href: "#"
}];
export default function Footer() {
  return <section data-section-id="1656" id="footer" className="relative dark bg-background text-foreground py-20 md:py-24">
      <div className="absolute top-0 left-0 right-0 flex items-center px-6 md:px-22">
        <span className="block h-[3px] w-[3px] bg-primary -translate-y-px" />
        <span className="block h-px flex-1 bg-primary" />
        <span className="block h-[3px] w-[3px] bg-primary -translate-y-px" />
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-22">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-4 flex flex-col gap-6">
            <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-primary">
              § 09 / FOOTER — CENTRAL FLORIDA
            </div>
            <Link to="/" className="inline-flex items-center gap-2 group">
              <WvcLogo className="h-8 w-auto" />
              <span className="block h-1 w-1 bg-primary" />
            </Link>
            <p className="font-default italic text-lg leading-snug text-muted-foreground" style={{
            fontFamily: "var(--font-serif)"
          }}>
              Supporting families with hope, advocacy, and connection.
            </p>
            <div className="font-default text-[0.78rem] tracking-[0.16em] uppercase text-muted-foreground leading-relaxed">
              CENTRAL FLORIDA HQ
              <br />
              <span className="text-foreground/80">
                (407) 555-0199 / HELLO@HOPETORCHLIGHTERS.ORG
              </span>
            </div>

            <div className="hidden md:flex items-center gap-2 pt-2">
              <span className="font-default text-[0.7rem] tracking-[0.18em] text-primary">+</span>
              <span className="block h-px w-12 bg-border" />
              <span className="font-default text-[0.7rem] tracking-[0.18em] text-muted-foreground">
                ESTABLISHED 2018
              </span>
            </div>
          </div>

          <div className="md:col-span-4 md:border-l md:border-border md:pl-8">
            <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-primary mb-6">
              § Navigation
            </div>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="md:col-span-4 md:border-l md:border-border md:pl-8 flex flex-col gap-8">
            <div>
              <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-primary mb-4">
                § Community
              </div>
              <Link to="#" className="group inline-flex items-center gap-3 font-default text-2xl text-foreground hover:text-primary transition-colors duration-300" style={{
              fontFamily: "var(--font-serif)"
            }}>
                <span>
                  Join the <em className="text-primary">Movement</em>
                </span>
                <ArrowUpRight className="size-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.25} />
              </Link>
              <p className="mt-3 font-default text-[0.72rem] tracking-[0.14em] uppercase text-muted-foreground">
                Empowering families through advocacy and inclusive programs.
              </p>
            </div>

            <div>
              <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-muted-foreground mb-4">
                § Connect
              </div>
              <div className="flex items-center gap-5">
                {socials.map((social, i) => {
                const Icon = social.icon;
                return <Link key={social.name} data-index={i} to={social.href} aria-label={social.name} className="text-muted-foreground hover:text-primary transition-colors duration-250">
                      <Icon className="size-5" strokeWidth={1.25} />
                    </Link>;
              })}
              </div>
            </div>

            <div className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-muted-foreground">
              501(C)(3) NONPROFIT ORGANIZATION
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-border flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="relative flex-1 overflow-hidden">
            <div className="flex gap-8 animate-[ticker_60s_linear_infinite] whitespace-nowrap will-change-transform">
              {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-8 font-default text-[0.72rem] tracking-[0.18em] uppercase text-muted-foreground">
                  <span>{item}</span>
                  <span className="block h-1 w-1 bg-primary" />
                </div>)}
            </div>
          </div>

          <div className="flex items-center gap-6 md:pl-6 md:border-l md:border-border">
            {legalLinks.map((link, i) => <Link key={link.label} data-index={i} to={link.href} className="font-default text-[0.72rem] tracking-[0.18em] uppercase text-muted-foreground hover:text-primary transition-colors duration-250">
                {link.label}
              </Link>)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}